<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="mt-2 mb-3">
          <div class="text-h6">{{ $t('title') }}
            <v-tooltip bottom max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small color="grey" dark v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>{{ $t('tooltip') }}</span>
            </v-tooltip>

            <v-tooltip bottom max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                    to="/account/subscriptions"
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  :color="remainingUrlsCount === 0 ? 'error' : (remainingUrlsCount < 50 ? 'warning' : 'success')"
                  label
                  outlined>
                  {{ $services.urlMonitoring.urlMonitors.all.length }} / {{ $account.current.rules['check-position'].max_url_monitor }}
                </v-chip>
              </template>
              <span>
                {{ $t('add-url') }}
                {{ $account.current.rules['check-position'].max_url_monitor }}
                {{ $t('increase-keywords') }}
              </span>
            </v-tooltip>
          </div>
          <div v-if="false" style="color: rgba(0, 0, 0, 0.6); font-size: 12px; margin-top: -6px;">{{ layout.name }}</div>
        </div>
      </v-col>
    </v-row>

    <page-buttons
      :selected="selected"
      :order="order">
    </page-buttons>

    <page-search
      :search="search"
      @changed="onSearch"
      @filter="onFilter">
    </page-search>

    <page-table
      :search="search"
      :filter="filter"
      @select="onSelect"
      @sort="onSort"
      @search="onSearch">
    </page-table>

    <add-urls-dialog></add-urls-dialog>
    <refresh-urls-dialog></refresh-urls-dialog>
    <remove-urls-dialog></remove-urls-dialog>
  </v-container>
</template>

<script>
import PageButtons from '@/views/Pages/UrlMonitoring/Components/PageButtons'
import PageSearch from '@/views/Pages/UrlMonitoring/Components/PageSearch'
import PageTable from '@/views/Pages/UrlMonitoring/Components/PageTable'
import AddUrlsDialog from '@/views/Pages/UrlMonitoring/Dialogs/AddUrlsDialog'
import RefreshUrlsDialog from '@/views/Pages/UrlMonitoring/Dialogs/RefreshUrlsDialog'
import RemoveUrlsDialog from '@/views/Pages/UrlMonitoring/Dialogs/RemoveUrlsDialog'

export default {
  name: 'MonitoringLayoutPage',
  components: { RemoveUrlsDialog, RefreshUrlsDialog, AddUrlsDialog, PageTable, PageSearch, PageButtons },
  data () {
    return {
      selected: [],
      order: [],
      search: '',
      filter: '',
    }
  },
  computed: {
    remainingUrlsCount () {
      return 200 - this.$services.urlMonitoring.urlMonitors.all.length
    }
  },
  methods: {
    onSearch (search) {
      this.search = search
    },
    onFilter (filter) {
      this.filter = filter
    },
    onSelect (selected) {
      this.selected = selected
    },
    onSort (order) {
      this.order = order
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"title": "URL indexing tracking",
		"tooltip": "This tool checks day after day for the presence of a list of URLs in Google's results pages.",
		"add-url": "You can add up to ",
		"increase-keywords": "URL. Click here to increase this limit."
	},
	"es": {
		"title": "Seguimiento de indexación de URL",
		"tooltip": "Esta herramienta comprueba día tras día la presencia de una lista de URL en las páginas de resultados de Google.",
		"add-url": "Puedes sumar hasta ",
		"increase-keywords": "URL. Haga clic aquí para aumentar este límite."
	},
	"fr": {
		"title": "Suivi d'indexation d'URL",
		"tooltip": "Cet outil vérifie jour après jour la présence d'une liste d'URL dans les pages de résultats de Google.",
		"add-url": "Vous pouvez ajouter jusqu'à ",
		"increase-keywords": "URL. Cliquez ici pour augmenter cette limite."
	},
	"it": {
		"title": "Monitoraggio indicizzazione URL",
		"tooltip": "Questo strumento verifica giorno dopo giorno la presenza di una lista di URL nelle pagine dei risultati di Google.",
		"add-url": "Puoi aggiungere fino a ",
		"increase-keywords": "URL. Clicca qui per aumentare questo limite."
	},
	"pt": {
		"title": "Monitorização de indexação de URL",
		"tooltip": "Esta ferramenta verifica dia após dia a presença de uma lista de URLs nas páginas de resultados do Google.",
		"add-url": "Pode adicionar até ",
		"increase-keywords": "URL. Clique aqui para aumentar este limite."
	},
	"pl": {
		"title": "Śledzenie indeksacji URL",
		"tooltip": "Narzędzie to sprawdza dzień po dniu obecność listy adresów URL na stronach wyników Google.",
		"add-url": "Możesz dodać do ",
		"increase-keywords": "URL. Kliknij tutaj, aby zwiększyć ten limit."
	}
}
</i18n>
